<div class="cap-list-renderer-bulk-actions">
  <div class="bulk-action-title">
    {{ 'builders.ui.rows-selected' | translate : {amount: selectedItems.length} }}
  </div>

  @if (contentTemplate) {
    <div class="bulk-action-content">
      <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ items: selectedItems }">
      </ng-container>
    </div>
  }

  <div class="button-container">
    <cap-button styleClass="secondary"
                [attr.data-test]="'builder-bulk-cancel'"
                (click)="handleCancelSelection()"
                [label]="'builders.ui.cancel-selection' | translate">
    </cap-button>

    @if (actions.length > 1) {
      <cap-button styleClass="primary"
                  [attr.data-test]="'builder-bulk-perform'"
                  [label]="'builders.ui.perform-bulk-action' | translate"
                  (click)="isOpen = !isOpen" cdkOverlayOrigin #trigger="cdkOverlayOrigin"></cap-button>
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayPositions]="positions"
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOpen"
        (overlayOutsideClick)="isOpen = false">
          <div class="action-panel">
            <ul class="row-action__items bulk-items" [ngClass]="{'row-action__items--open': isOpen}">
                @for (action of actions; track action.key) {
                  @if ((action?.hidden | observablePipe | async) !== true) {
                    <li (click)="executeAction(action)"
                        [attr.data-test]="action?.key || action?.value">
                      <div class="row-action__icon">
                        <i [class]="action?.icon"></i>
                      </div>

                      <div class="row-action__info">
                        <p class="title">
                          {{ action?.label | observablePipe | async }}
                        </p>

                        @if (action?.description | observablePipe | async; as description) {
                          <p class="description">
                            {{ description }}
                          </p>
                        }
                      </div>
                    </li>
                  }
                }
            </ul>
          </div>
      </ng-template>
    }

    @if (actions.length === 1) {
      <cap-button styleClass="primary"
                  [attr.data-test]="'builder-bulk-' + actions[0].key"
                  [label]="actions[0].label | observablePipe | async"
                  [icon]="actions[0].icon"
                  (click)="executeAction(actions[0])">
      </cap-button>
    }
  </div>
</div>
